import { ACTIVATE_ACCOUNT, REGISTER_COMPANY, REGISTER_COMPANY_ERROR, REGISTER_COMPANY_SUCCESS, REGISTER_PERSONALUSER, REGISTER_PERSONALUSER_ERROR, REGISTER_PERSONALUSER_SUCCESS } from "./actionTypes"

export const registerCompany = (data, history) => {
  return {
    type: REGISTER_COMPANY,
    payload: { data, history },
  }
}

export const registerCompanySuccess = user => {
  return {
    type: REGISTER_COMPANY_SUCCESS,
    payload: user,
  }
}

export const registerCompanyError = error => {
  return {
    type: REGISTER_COMPANY_ERROR,
    payload: error,
  }
}

export const registerPersonalUser = (data, history) => {
  return {
    type: REGISTER_PERSONALUSER,
    payload: { data, history },
  }
}

export const registerPersonalUserSuccess = user => {
  return {
    type: REGISTER_PERSONALUSER_SUCCESS,
    payload: user,
  }
}

export const registerPersonalUserError = error => {
  return {
    type: REGISTER_PERSONALUSER_ERROR,
    payload: error,
  }
}

export const activateAccount = (data, history) => {
  return {
    type: ACTIVATE_ACCOUNT,
    payload: { data, history },
  }
}
